export const formatDate = (oldInput: string, newInput: string): string => {
  const trailingSlash = newInput === `${oldInput}/` ? "/" : "";

  const digits = newInput.split("").filter((x: string) => !isNaN(pInt(x)));

  const month = formatMonthDay({
    firstNum: pInt(`${digits[0]}`),
    secondNum: pInt(`${digits[1]}`),
    firstNumMax: 1,
    max: 12,
  });

  if (!month) return newInput.slice(0, -1);

  const day = formatMonthDay({
    firstNum: pInt(`${digits[2]}`),
    secondNum: pInt(`${digits[3]}`),
    firstNumMax: 3,
    max: 31,
  });

  if (month && !day) return `${month}${trailingSlash}`;

  const year = formatYear(pInt(`${digits[4]}${digits[5]}${digits[6]}${digits[7]}`));

  if (month && day && !year) return `${[month, day].join("/")}${trailingSlash}`;

  return `${[month, day, year].join("/")}${trailingSlash}`;
};

const pInt = (input: string): number => parseInt(input, 10);

const formatMonthDay = ({
  firstNum,
  secondNum,
  firstNumMax,
  max,
}: {
  firstNum: number;
  secondNum: number;
  firstNumMax: number;
  max: number;
}): string | undefined => {
  if (!isNaN(firstNum) && isNaN(secondNum)) {
    if (firstNum > firstNumMax) return;
    if (firstNum <= firstNumMax) return `${firstNum}`;
  }

  if (!isNaN(secondNum)) {
    const inputNum = pInt(`${firstNum}${secondNum}`);
    const isZero = `${firstNum}${secondNum}` === "00";

    if (inputNum > max || isZero) return `${firstNum}`;
    if (inputNum <= max) return `${firstNum}${secondNum}`;
  }
};

const formatYear = (year: number): string | undefined => {
  if (!isNaN(year)) return `${year}`;
};
